import { PAGES, CROSSWORD_PUBLISHER_DATA } from "@consts";

/**
 * Only allow approved publishers.
 */
export default ({ route, redirect }) => {
	if (![PAGES.CLUES_PUBLISHER].includes(route.name)) {
		return;
	}

	const publisherSlug = route?.params?.publisher || "";

	const approvedPublisherSlugs = CROSSWORD_PUBLISHER_DATA.map(
		(publisher) => publisher.slug
	);

	if (!approvedPublisherSlugs.includes(publisherSlug)) {
		return redirect("/crosswords/");
	}
};
